import { ArrowUpRight, Clock, CalendarDays, ShoppingCart, MessageCircle, Wallet, Store, MessageSquareText, ClipboardCheck, Phone } from "lucide-react";

// ── 自社サービス：やさまるシリーズ ──
const ownProducts = [
    {
        id: "yasamaru-time",
        name: "やさまるタイム",
        category: "勤怠管理",
        Icon: Clock,
        bg: "bg-[#7DB856]",
        accent: "bg-[#E6F2D6]",
        description: "出退勤の打刻から、集計・休暇申請までを「やさしく」まとめた勤怠管理SaaS。",
        features: ["ワンタップ打刻", "自動集計", "シフト連携"],
        screenshot: "/screenshots/yasamaru_time.png",
        noBlur: true,
        status: "稼働中",
        href: "https://yasamarutime.online",
    },
    {
        id: "yasamaru-shift",
        name: "やさまるシフト",
        category: "シフト作成 / 管理",
        Icon: CalendarDays,
        bg: "bg-[#4DA8DA]",
        accent: "bg-[#DCEDF7]",
        description: "希望提出から自動シフト作成、LINE通知までを1つにまとめた、店長のためのシフトマネージャー。",
        features: ["希望収集", "自動作成", "LINE通知"],
        screenshot: "/screenshots/yasamaru_shift.png",
        noBlur: true,
        status: "稼働中",
        href: "https://shiftmagic.com",
    },
];

// ── これまでの提案・受託開発事例 ──
const proposals = [
    {
        id: "case-order",
        name: "受発注システム",
        category: "受発注 / 商品カタログ",
        Icon: ShoppingCart,
        bg: "bg-[#E5A847]",
        accent: "bg-[#FFF1D6]",
        description: "店舗ごとの商品カタログ・特売情報・カート・注文履歴を1つに。FAX/電話の注文を、まるごとデジタル化。",
        features: ["商品カタログ", "AI提案", "注文履歴"],
        screenshot: "/screenshots/yasamaru_kun.png",
    },
    {
        id: "case-link",
        name: "顧客管理 / 社内連絡システム",
        category: "CRM / 配送管理",
        Icon: MessageCircle,
        bg: "bg-[#5BB99D]",
        accent: "bg-[#DEF2EA]",
        description: "顧客一覧から配送コース、日報、営業活動までを1つに。営業から現場まで、やさしく繋ぐ業務プラットフォーム。",
        features: ["顧客DB", "配送日報", "営業ミッション"],
        screenshot: "/screenshots/yasamaru_link.png",
    },
    {
        id: "case-reach",
        name: "営業活動・コール管理システム",
        category: "セールス / コール分析",
        Icon: Phone,
        bg: "bg-[#118AB2]",
        accent: "bg-[#D7E9F2]",
        description: "通話履歴・接続率・コール結果を見える化。新規開拓から既存フォローまで、営業活動を数字で動かす。",
        features: ["通話分析", "接続率", "ターゲット管理"],
        screenshot: "/screenshots/yasamaru_reach.png",
    },
    {
        id: "case-cashbook",
        name: "現金出納帳 / 利益可視化システム",
        category: "経理 / ダッシュボード",
        Icon: Wallet,
        bg: "bg-[#C26A8A]",
        accent: "bg-[#F5DDE7]",
        description: "毎日の現金出納から、利益のリアルタイム可視化まで。経営の「いま」が、まるく見える。",
        features: ["出納帳", "受信ボックス", "学習パターン"],
        screenshot: "/screenshots/yasamaru_omni.png",
    },
    {
        id: "case-store",
        name: "飲食店 売上 / 目標システム",
        category: "店舗運営 / 多店舗管理",
        Icon: Store,
        bg: "bg-[#7DB856]",
        accent: "bg-[#E6F2D6]",
        description: "飲食店の日々の売上と目標達成を、ダッシュボードでまるっと管理。店舗ごとの進捗・人件費まで一目で。",
        features: ["目標進捗", "店舗比較", "人件費管理"],
        screenshot: "/screenshots/paueru.png",
    },
    {
        id: "case-linebot",
        name: "LINE レシート自動記録・応答システム",
        category: "LINE bot / OCR",
        Icon: MessageSquareText,
        bg: "bg-[#06C755]",
        accent: "bg-[#D7F3E1]",
        description: "LINEに送ったレシートを自動で読み込み、家計簿・経費に登録。日常の延長で、業務がまわる。",
        features: ["レシートOCR", "LINE連携", "自動応答"],
        screenshot: "/screenshots/linebot.jpg",
        screenshotFit: "object-top",
    },
    {
        id: "case-welfare",
        name: "就労支援B型 業務報告アプリ",
        category: "福祉 / 業務報告",
        Icon: ClipboardCheck,
        bg: "bg-[#9B7BB8]",
        accent: "bg-[#EBE0F2]",
        description: "B型就労継続支援施設向けの業務報告アプリ。利用者ごとの記録・工賃計算・支援記録を一元化。",
        features: ["日次報告", "工賃計算", "支援記録"],
        screenshot: "/screenshots/welfare.png",
    },
];

function AppCard({ a, showStatus }) {
    const Wrapper = a.href ? "a" : "article";
    const wrapperProps = a.href
        ? { href: a.href, target: "_blank", rel: "noopener noreferrer" }
        : {};
    return (
        <Wrapper
            {...wrapperProps}
            data-testid={`app-card-${a.id}`}
            className="group relative rounded-2xl bg-white border border-[#E6EFD8] shadow-soft hover:shadow-soft-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
        >
            {/* Preview area: screenshot if available, else mini UI mock */}
            <div className={`${a.accent} relative overflow-hidden ${a.noBlur ? "h-64 sm:h-72" : "h-56"}`}>
                {a.screenshot ? (
                    <>
                        <img
                            src={a.screenshot}
                            alt={`${a.name} のUIプレビュー`}
                            className={`absolute inset-0 w-full h-full object-cover ${a.screenshotFit || "object-top"} group-hover:scale-[1.03] transition-transform duration-500`}
                            style={
                                a.noBlur
                                    ? undefined
                                    : { filter: "blur(3.5px) saturate(1.05)" }
                            }
                            draggable={false}
                            loading="lazy"
                        />
                        {!a.noBlur && (
                            <>
                                <div
                                    aria-hidden
                                    className="absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-white/15 pointer-events-none"
                                />
                                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm text-[10px] font-bold tracking-widest uppercase text-[#4A7A2F] border border-white">
                                    UI Preview
                                </span>
                            </>
                        )}
                    </>
                ) : (
                    <div className="p-4 h-full">
                        <div className="absolute -top-6 -right-6 w-20 h-20 rounded-full bg-white/40" />
                        <div className="relative h-full">
                            <a.Mock />
                        </div>
                    </div>
                )}
            </div>

            <div className="p-5 sm:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                    <span
                        className={`inline-flex items-center justify-center w-9 h-9 rounded-xl ${a.bg} text-white`}
                    >
                        <a.Icon size={18} strokeWidth={2.5} />
                    </span>
                    <span className="text-[11px] font-bold tracking-widest uppercase text-[#8A9690]">
                        {a.category}
                    </span>
                </div>

                <h3 className="text-xl sm:text-2xl font-bold text-[#2F5F1A] tracking-tight leading-tight">
                    {a.name}
                </h3>
                <p className="mt-2 text-sm text-[#5C6B5E] leading-relaxed flex-1">
                    {a.description}
                </p>

                <div className="mt-4 flex flex-wrap gap-1.5">
                    {a.features.map((f) => (
                        <span
                            key={f}
                            className="px-2.5 py-1 rounded-full bg-[#F0F7E8] text-[#4A7A2F] text-[11px] font-bold"
                        >
                            {f}
                        </span>
                    ))}
                </div>

                {showStatus && (
                    <div className="mt-5 pt-4 border-t border-[#E6EFD8] flex items-center justify-between">
                        <span className="inline-flex items-center gap-1.5 text-xs font-bold text-[#4A7A2F]">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#7DB856]" />
                            {a.status}
                        </span>
                        {a.href ? (
                            <span className="inline-flex items-center gap-1 text-xs font-bold text-[#2F5F1A] group-hover:text-[#7DB856] transition-colors">
                                サイトへ
                                <ArrowUpRight
                                    size={14}
                                    strokeWidth={2.75}
                                    className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                                />
                            </span>
                        ) : (
                            <span className="inline-flex items-center gap-1 text-xs font-bold text-[#2F5F1A] group-hover:text-[#7DB856] transition-colors">
                                詳しく
                                <ArrowUpRight
                                    size={14}
                                    strokeWidth={2.75}
                                    className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                                />
                            </span>
                        )}
                    </div>
                )}
            </div>
        </Wrapper>
    );
}

export default function Portfolio() {
    return (
        <section
            id="works"
            data-testid="portfolio-section"
            className="relative py-24 sm:py-32 bg-[#FAFCF5]"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="text-center max-w-3xl mx-auto mb-14">
                    <div
                        data-testid="portfolio-label"
                        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#C8E0AC] text-xs font-bold tracking-widest uppercase text-[#4A7A2F]"
                    >
                        WORKS — 制作実績
                    </div>
                    <h2
                        data-testid="portfolio-title"
                        className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1F2A23] leading-tight"
                    >
                        これまでの
                        <span className="text-[#7DB856]">提案事例</span>
                        と、
                        <br />
                        自社サービス。
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-[#5C6B5E] leading-relaxed">
                        受発注、顧客管理、経理、店舗運営、LINEbot、福祉現場まで。 様々な業界の「困った」を、Webアプリでまるく解決してきました。
                    </p>
                </div>

                {/* ── 自社サービス：やさまるシリーズ ── */}
                <div data-testid="portfolio-own" className="mb-20">
                    <div className="flex items-end justify-between flex-wrap gap-3 mb-7">
                        <div>
                            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#7DB856]">
                                — Our Products
                            </div>
                            <h3 className="mt-2 text-2xl sm:text-3xl font-bold text-[#2F5F1A]">
                                自社サービス「やさまるシリーズ」
                            </h3>
                        </div>
                        <p className="text-sm text-[#5C6B5E] max-w-md">
                            これまでの開発ノウハウを、誰でも使えるSaaSに。 月額で始められる自社プロダクトです。
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
                        {ownProducts.map((a) => (
                            <AppCard key={a.id} a={a} showStatus />
                        ))}
                    </div>
                </div>

                {/* ── これまでの提案事例 ── */}
                <div data-testid="portfolio-cases">
                    <div className="flex items-end justify-between flex-wrap gap-3 mb-7">
                        <div>
                            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#E5A847]">
                                — Case Studies
                            </div>
                            <h3 className="mt-2 text-2xl sm:text-3xl font-bold text-[#2F5F1A]">
                                これまでの提案事例
                            </h3>
                        </div>
                        <p className="text-sm text-[#5C6B5E] max-w-md">
                            業務内容に合わせて、オーダーメイドで設計・開発した実績の一部です。
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                        {proposals.map((a) => (
                            <AppCard key={a.id} a={a} />
                        ))}
                    </div>
                </div>

                <div className="mt-14 text-center">
                    <p className="text-sm text-[#5C6B5E]">
                        ほかにも、貴社の業務に合わせたオーダーメイド開発が可能です。
                    </p>
                </div>
            </div>
        </section>
    );
}
